import firebase from 'firebase/compat/app';

export class SignUp {
  id: string;
  uid?: string;
  programId: string;
  created: firebase.firestore.Timestamp;
  modified: firebase.firestore.Timestamp;
}
